'use client';

import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';

type HeaderTooltipProps = {
  tooltipText: string;
  children: React.ReactNode;
};

export default function HeaderTooltip({
  tooltipText,
  children,
}: HeaderTooltipProps) {
  return (
    <Tooltip disableHoverableContent delayDuration={300}>
      <TooltipTrigger asChild>
        <div className='relative'>{children}</div>
      </TooltipTrigger>
      <TooltipContent
        align='center'
        side='bottom'
        className='rounded border border-gray-200 bg-white px-2 py-1 text-xs text-gray-900 shadow'
      >
        {tooltipText}
      </TooltipContent>
    </Tooltip>
  );
}
